angular
  .module('picmonic-common')
  .controller('RegisterModalController', [
    '$scope',
    '$modalInstance',
    '$controller',
    '$location',
    'UserService',
    'MarketOptionsConfig',
    'card',
    'copy',
    'market_id',
    'redirect',
    'tab',
    '$cookies',
    '$modal',
    'registration_source_page',
    '$state',
    '$timeout',
    '$stateParams',
    'ClassOfficerService',
    'SplitTestService',
    '$animate',
    'ngBowser',
    'FreePremiumTrialModal',
    'extraParams',
    function (
      $scope,
      $modalInstance,
      $controller,
      $location,
      UserService,
      MarketOptionsConfig,
      card,
      copy,
      market_id,
      redirect,
      tab,
      $cookies,
      $modal,
      registration_source_page,
      $state,
      $timeout,
      $stateParams,
      ClassOfficerService,
      SplitTestService,
      $animate,
      ngBowser,
      FreePremiumTrialModal,
      extraParams
    ) {
      $controller('LoginController', { $scope: $scope });
      $controller('RegisterStep1Controller', { $scope: $scope });

      $scope.educatorFilter = function (market) {
        if ($state.current.name !== 'public.educators') {
          return true;
        } else if (!market.is_beta && market.id != 103) {
          return true;
        }

        return false;
      };

      $scope.contractFilter = function (market) {
        if (
          extraParams &&
          extraParams.contract &&
          !extraParams.contract.schools.filter(function (school) {
            return school.market_id == market.id;
          }).length
        ) {
          return false;
        }

        return true;
      };

      $scope.institutional = $state.current.name === 'public.institutional-login';
      if ($scope.institutional) {
        $scope.user.use_ip_address = 1;
      }

      $scope.UserService = UserService;
      $scope.MarketOptionsConfig = MarketOptionsConfig;
      $scope.extraParams = extraParams;

      $scope.current_url = location.pathname;
      $scope.$state = $state;

      $scope.registerTitle =
        $scope.registerModal && $scope.registerModal.registerTitle
          ? $scope.registerModal.registerTitle
          : 'Join Picmonic Free';
      $scope.user.email =
        $scope.registerModal && $scope.registerModal.email
          ? $scope.registerModal.email
          : $cookies.get('pls_user_email')
          ? $cookies.get('pls_user_email')
          : $scope.user.email;
      $scope.user.full_name =
        $scope.registerModal && $scope.registerModal.full_name ? $scope.registerModal.full_name : $scope.user.full_name;
      $scope.copy = copy
        ? copy
        : '<span>Unlock free daily content.<br /><span class="pls-font-weight-600">No credit card required.</span></span>';
      $scope.card = card;
      $scope.$emit('endInteraction');

      // Auto focus password field when email and name are already filled out
      if ($scope.user.email && $scope.user.full_name) {
        $timeout(function () {
          angular.element('input[name=password]').focus();
        });
      }

      $scope.name = card ? card.name : '';

      // Default the market ID to user's lead, then cookie, then 100 as fallback
      if (!market_id) {
        market_id = $cookies.get('pls_user_lead') ? $cookies.get('pls_user_lead') : null;
      }

      $scope.tab = tab ? tab : $cookies.get('userId') ? 'login' : 'register';

      if (market_id) {
        $scope.market = MarketOptionsConfig.getMarketById(market_id);
        $scope.market_name = $scope.school_name;
      }

      // Blank out email if logging in through LTI
      if ($scope.registerModal && $scope.registerModal.lti) {
        $scope.user.email = null;
        $scope.user.lti = 1;

        if ($location.search().lti_session_id) {
          $scope.user.lti_session_id = UserService.user.lti_session_id = $location.search().lti_session_id;
        }
      }

      if ($scope.registerModal && $scope.registerModal.link) {
        $scope.user.transfer_account = 1;
      }

      $scope.$watch(
        function () {
          return $scope.tab;
        },
        function (newValue) {
          $scope.classOfficers = ClassOfficerService.getClassOfficersByLead(UserService.user.lead);

          if (newValue !== 'register') {
            $timeout(function () {
              angular.element('.registration-cta-modal').removeClass('value-add-modal');
            });
          } else if (newValue === 'register' && $scope.market && $scope.market.picmonics && $scope.market.facts) {
            $timeout(function () {
              angular.element('.registration-cta-modal').addClass('value-add-modal');

              $timeout(function () {
                angular.element('.animate-ls').each(function (index, element) {
                  $timeout(function () {
                    $animate.addClass(element, 'pls-animation-left-slide');
                  }, index * 150);
                });
              }, 500);
            });
          }
        }
      );

      send_ga('event', 'Register', 'Registration Modal', 'Tab: ' + $scope.tab);
      if (typeof atlasEvent !== 'undefined') {
        atlasEvent('registration-modal', 'Tab: ' + $scope.tab, 'new_user');
        atlasEvent('registration-modal', 'Tab: ' + $scope.tab, 'user_flow_7_2017', 'required');
      }

      $scope.years = [];
      var start_year = new Date().getFullYear();
      for (var a = 0; a < 10; a++) {
        $scope.years.push(start_year + a);
      }

      $scope.months = {
        1: 'January',
        2: 'February',
        3: 'March',
        4: 'April',
        5: 'May',
        6: 'June',
        7: 'July',
        8: 'August',
        9: 'September',
        10: 'October',
        11: 'November',
        12: 'December',
      };

      //Submit user object to user endpoint (update user)
      $scope.submitSchool = function () {
        if ($scope.form.$invalid) {
          $scope.error = 'Please complete all required fields';
          return;
        } else {
          $scope.error = '';
        }

        if (
          UserService.user.graduation_year ||
          UserService.user.graduation_month ||
          UserService.user.student_officer ||
          UserService.user.link ||
          (UserService.user.school && UserService.user.school.id)
        ) {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('click', 'registration step 3 finished');
          }
        } else {
          if (typeof atlasEvent !== 'undefined') {
            atlasEvent('click', 'registration step 3 skipped');
          }
        }

        $scope.loading = true;
        $scope.error = null;

        if (UserService.user.role === 'Professor') {
          UserService.user.educator = 1;
        }

        UserService.user.$update(
          function () {
            $scope.checkRedirect();
          },
          function (error) {
            $scope.error = error.data.message;
            $scope.loading = false;
          }
        );
      };

      $scope.checkRedirect = function () {
        var userAgent = navigator.userAgent || navigator.vendor || window.opera;
        var isMobileAndroidApp = userAgent.indexOf('Crosswalk') > -1 || userAgent.indexOf('CriOS') > -1;
        var urlparams = $location.search();

        if (!UserService.user.tos_accepted) {
          top.location = '/find-picmonic';
        } else if (card && card.slug) {
          document.location.href = '/learn/' + card.slug;
        } else if (redirect) {
          if (redirect === 'close') {
            $modalInstance.close();
          } else if (redirect === 'reload') {
            location.reload();
          } else if (!isMobileAndroidApp && ngBowser.isMobile()) {
            top.location =
              $location.protocol() +
              '://' +
              $location.host() +
              '/login/mobile-app?redirect=' +
              encodeURIComponent(redirect);
          } else if (redirect.indexOf('?newWindow') !== -1) {
            window.open(redirect);
            $modalInstance.close();
          } else {
            document.location.href = redirect;
          }
        } else {
          if (UserService.user.role === 'Affiliate') {
            top.location = '/affiliate-portal';
          } else if ($scope.tab == 'login') {
            if (!isMobileAndroidApp && ngBowser.isMobile() && redirect === 'reload') {
              top.location =
                $location.protocol() +
                '://' +
                $location.host() +
                '/login/mobile-app?redirect=' +
                (urlparams.redirect ? urlparams.redirect : '/home');
            } else {
              if (window.location.pathname == '/lti/select') {
                $location.search('api_key', UserService.user.web_api_key);
                window.location = $location.absUrl();
                return;
              }
              if (window.location.pathname == '/') {
                window.location = '/home';
                return;
              }
              location.reload();
            }
          } else {
            top.location = '/find-picmonic';
          }
        }
      };

      $scope.submitModalAppleLogin = function () {
        AppleID.auth.init({
          clientId: 'com.picmonic.web-applesignin',
          redirectURI: location.origin + '/login/apple',
          scope: 'email name',
          state: 'login',
        });
        AppleID.auth.signIn();
      };

      $scope.submitModalSocialLogin = function () {
        $scope.loading = true;
        $scope.loadingMode = 'login-social';
        $scope.error = '';

        $scope.socialLogin(false, redirect).then(
          function (result) {
            redirect = null;

            $scope.checkRedirect();
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitModalLogin = function () {
        if ($scope.login.$invalid) {
          return false;
        }

        $scope.loading = true;
        $scope.loadingMode = 'login-picmonic';
        $scope.error = '';

        $scope.appLogin(false, redirect).then(
          function (result) {
            redirect = null;

            $scope.checkRedirect();
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitModalGoogleLogin = function () {
        $scope.loading = true;
        $scope.loadingMode = 'login-google';
        $scope.error = '';

        $scope.googleLogin(false, redirect).then(
          function (result) {
            redirect = null;

            $scope.checkRedirect();
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitGoogleRegister = function () {
        $scope.loading = true;
        $scope.loadingMode = 'registration-google';
        $scope.error = '';

        if (market_id) {
          if (!MarketOptionsConfig.getMarketById(market_id).is_pseudo) {
            UserService.user.lead = market_id;
          }
          UserService.user.role = 'Student';
        }
        if ($state.current.name === 'public.affiliates') {
          UserService.user.role = 'Affiliate';
        }

        UserService.user.registration_source_page = registration_source_page;

        // Call RegisterStep1Controller.register
        $scope.googleRegister(false, redirect).then(
          function (data) {
            $scope.loading = false;
            var market;

            if (data && data.lead) {
              market = MarketOptionsConfig.getMarketById(data.lead);
              $scope.tab = 'login';
            }

            $scope.tab = 'market';
            $scope.social = true;
            $scope.loading = false;
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitModalSocialRegistration = function () {
        $scope.loading = true;
        $scope.loadingMode = 'registration-social';
        $scope.error = '';

        if (market_id) {
          if (!MarketOptionsConfig.getMarketById(market_id).is_pseudo) {
            UserService.user.lead = market_id;
          }
          UserService.user.role = 'Student';
        }
        if ($state.current.name === 'public.affiliates') {
          UserService.user.role = 'Affiliate';
        }

        UserService.user.registration_source_page = registration_source_page;

        // Call RegisterStep1Controller.register
        $scope.socialRegister(false, redirect).then(
          function (data) {
            $scope.loading = false;
            var market;

            if (data && data.lead) {
              market = MarketOptionsConfig.getMarketById(data.lead);
              $scope.tab = 'login';
            }

            if ($scope.splitTest === 'b') {
              $scope.tab = 'market';
              $scope.loading = false;
              $scope.social = true;
              return;
            }

            if (market && redirect && redirect.indexOf('nursing-nclex-question-of-the-day') !== -1) {
              $scope.checkRedirect();
            } else if (!market || (market && market.is_pseudo)) {
              $scope.tab = 'market';
            } else if (
              market &&
              (!(data.school && data.school.school_id) || !data.graduation_year || !data.graduation_month) &&
              !$stateParams.skip_step_3
            ) {
              if (typeof atlasEvent !== 'undefined') {
                atlasEvent('click', 'registration step 2 skipped');
              }
              if ($state.current.name === 'public.educators') {
                UserService.user.role = 'Professor';
              }
              $scope.tab = 'school';
            } else {
              $scope.checkRedirect();
            }
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitModalRegistration = function () {
        if ($scope.loading) {
          return;
        }

        if (market_id) {
          if (!MarketOptionsConfig.getMarketById(market_id).is_pseudo) {
            $scope.user.lead = market_id;
          }
          $scope.user.role = 'Student';
        }
        if ($state.current.name === 'public.affiliates') {
          UserService.user.role = 'Affiliate';
        }
        $scope.user.accessToken = null;
        $scope.user.registration_source_page = registration_source_page;
        $scope.loading = true;
        $scope.loadingMode = 'registration-picmonic';
        $scope.error = '';
        if ($scope.step1.$invalid) {
          $scope.loading = false;
          return false;
        }

        // Blank name and random password for step 1
        $scope.user.full_name = '';
        $scope.user.password = Math.random().toString(36).slice(-8);

        // Call RegisterStep1Controller.register
        $scope.register(false, redirect).then(
          function (data) {
            var market;

            // Check if the user already has an account and we instead logged them in
            if (data && data.lead) {
              market = MarketOptionsConfig.getMarketById(data.lead);
              $scope.tab = 'login';
            }

            $scope.tab = 'market';
            $scope.loading = false;

            if ($state.current.name === 'public.educators') {
              UserService.user.role = 'Professor';
            }
          },
          function (error) {
            $scope.error = error.data.message_html.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.submitMarket = function () {
        if (!$scope.user.lead) {
          $scope.error = 'Please select an area of Study.';
          return false;
        }

        UserService.user.role = $scope.user.role;

        if (!$scope.social) {
          parsedName = UserService.parseFullName($scope.user.full_name);
          UserService.user.first_name = parsedName['first_name'];
          UserService.user.last_name = parsedName['last_name'];
          UserService.user.password = $scope.user.password;
        }

        market = MarketOptionsConfig.getMarketById($scope.user.lead);
        $scope.loading = true;
        $scope.error = null;

        UserService.user.$update(
          function (data) {
            if (redirect && redirect.indexOf('nursing-nclex-question-of-the-day') !== -1) {
              $scope.checkRedirect();
            } else if (!$stateParams.skip_step_3 && !(extraParams && extraParams.contract)) {
              if ($state.current.name === 'public.educators') {
                UserService.user.role = 'Professor';
              }
              $scope.tab = 'school';
            } else {
              $scope.checkRedirect();
            }
          },
          function (error) {
            $scope.error = error.data.message.replace('/login', '/login?redirect=' + $scope.current_url);
            $scope.loading = false;
          }
        );
      };

      $scope.selectTab = function (tab) {
        $scope.tab = tab;
        if ($scope.tab === 'register') {
          $timeout(function () {
            angular.element('input[name="full_name"]').focus();
          });
        } else if ($scope.tab === 'login') {
          $timeout(function () {
            angular.element('input[name="email"]').focus();
          });
        }
      };

      $scope.close = function () {
        if (typeof atlasEvent !== 'undefined' && $scope.tab === 'school') {
          atlasEvent('click', 'registration step 3 skipped');
        }

        if ($scope.tab === 'school' && UserService.user.role === 'Professor') {
          if (!confirm('Registration incomplete. Free Premium access will not be granted.')) {
            return;
          }
          //window.document.getElementById('school-form-button').click();
          return;
        }

        var inIframe = false;
        try {
          inIframe = window.self !== window.top;
        } catch (e) {
          inIframe = true;
        }

        if (UserService.user.user_id && !inIframe) {
          $scope.checkRedirect();
        }
        $modalInstance.close();
      };
    },
  ])
  .value('tab', null)
  .value('card', false)
  .value('copy', '')
  .value('redirect', false)
  .value('market_id', false)
  .value('registration_source_page', null);
